var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-2 px-6 border rounded-lg mb-5",class:{
        'border-gray-200 bg-gray-100 text-gray-700 bg-gray-50' : _vm.variant === 'default',
        'border-blue-200 bg-blue-100 text-blue-700 bg-blue-50' : _vm.variant === 'info',
        'border-green-200 bg-green-100 text-green-700 bg-green-50' : _vm.variant === 'success',
        'border-red-200 bg-red-100 text-red-700 bg-red-50' : _vm.variant === 'error',
        'border-yellow-200 bg-yellow-100 text-yellow-700 bg-yellow-50' : _vm.variant === 'warning',
      }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }